module.exports = __webpack_public_path__ + "img/pr-2.36806c20.png";